import { useState } from "react";
import { DatePicker as RSDatePicker } from "rsuite";
import IsRequired from "./common/IsRequired";
import { rsDatePickerLocale } from "./DatePicker";
import { splitPickerChange } from "./datePickerValue";
import ValidationErrorMessage from "./ValidationErrorMessage";

function FormikTimePicker<U>(props: FormikTimeControlProps<U>) {
  const { config, formik, disabled, placeholder, onChange } = props;
  const { id, label, initialValue, isRequired } = config;
  const { values, handleBlur, setFieldValue } = formik;
  const value = values[id] ? values[id] : "";
  // An unfinished time, kept on screen while Formik holds undefined (ADV-320).
  const [draft, setDraft] = useState<Date | null>(null);
  return (
    <>
      {label && (
        <label style={{ display: "block" }} className="form-label" htmlFor={id}>
          {label}
          {isRequired && <IsRequired />}
        </label>
      )}
      <RSDatePicker
        aria-autocomplete="none"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            return false;
          }
        }}
        id={id}
        limitEndYear={100}
        className={`flex-100 d-block w-100${
          formik.touched[id] && (formik as any).errors[id] ? " is-invalid" : ""
        }`}
        placeholder={
          placeholder ? placeholder : initialValue ? `${initialValue}` : "--:--"
        }
        // placeholder="dd.mm.åååå"
        format={"HH:mm"}
        disabled={disabled}
        value={value ? new Date(value) : draft}
        onBlurCapture={(e) => {
          if (e.target.id === id) handleBlur(e);
        }}
        onChange={
          onChange
            ? onChange
            : (date) => {
                const next = splitPickerChange(date);
                setDraft(next.draft);
                setFieldValue(id, next.value ?? undefined, true);
              }
        }
        // ranges={[
        //   {
        //     label: "I dag",
        //     value: new Date(),
        //     placement: "bottom",
        //   },
        // ]}
        locale={rsDatePickerLocale}
      />

      <ValidationErrorMessage
        touched={formik.touched[id]}
        errorMessage={(formik as any).errors[id]}
      />
    </>
  );
}
export default FormikTimePicker;
